module.exports = __webpack_public_path__ + "img/Group 965t3.9678aac3.svg";